module.exports = __webpack_public_path__ + "static/media/future-of-javascript.8cc16894.md";